import { useState } from "react";
import { Loading, Table, Title, fmtDT, useData } from "@/ops/ui";
import { FilterBar, initRange, mapsLink } from "@/ops/filters";

const LOC = { ok: "Başarılı", outside: "Mesafe dışı", no_location: "Konum yok", no_reference: "Referans yok" };
const m = (v) => (v == null ? "-" : `${Math.round(v)} m`);

function LiveTable() {
  const [rows] = useData("/ops/admin/live");
  if (!rows) return <Loading />;
  return (
    <Table head={["Personel", "Proje", "Görevde", "Bugün okutma", "Son okutma", "GPS", "Son konum"]} testid="live-table">
      {rows.map((r) => (
        <tr key={`${r.employee.id}-${r.project_id}`}><td className="px-3 py-2 font-semibold">{r.employee.name}</td><td className="px-3 py-2">{r.project}</td>
          <td className="px-3 py-2">{r.on_duty ? <span className="font-semibold text-emerald-700">Giriş yaptı</span> : "-"}</td><td className="px-3 py-2">{r.scans_today}</td>
          <td className="px-3 py-2 text-xs">{r.last_scan ? `${fmtDT(r.last_scan.at)} · ${r.last_scan.checkpoint_name}` : "-"}</td>
          <td className="px-3 py-2 text-xs">{r.last_scan ? `${LOC[r.last_scan.location_status]} ${m(r.last_scan.distance_m)}` : "-"}</td>
          <td className="px-3 py-2 text-xs">{r.last_ping ? <a className="text-blue-700 underline" target="_blank" rel="noreferrer" href={mapsLink(r.last_ping.lat, r.last_ping.lng)}>{fmtDT(r.last_ping.at)}</a> : "-"}</td></tr>
      ))}
      {!rows.length && <tr><td colSpan={7} className="p-6 text-center text-zinc-500">Atanmış personel yok.</td></tr>}
    </Table>
  );
}

function History({ f }) {
  const [scans] = useData("/ops/admin/scans", f);
  const [rej] = useData("/ops/admin/rejects", f);
  if (!scans || !rej) return <Loading />;
  const rows = [...scans.map((s) => ({ ...s, kind: "ok" })), ...rej.map((r) => ({ ...r, kind: "rej" }))].sort((a, b) => b.at.localeCompare(a.at));
  return (
    <Table head={["Zaman", "Personel", "Kontrol noktası", "Sonuç", "GPS", "Mesafe", "Doğruluk", "Neden / uyarı"]} testid="history-table">
      {rows.map((r) => (
        <tr key={r.id} className={r.kind === "rej" ? "bg-red-50/50" : ""}><td className="whitespace-nowrap px-3 py-2">{fmtDT(r.at)}</td><td className="px-3 py-2">{r.employee_name}</td><td className="px-3 py-2">{r.checkpoint_name || "-"}</td>
          <td className="px-3 py-2 text-xs font-semibold">{r.kind === "rej" ? <span className="text-red-700">Reddedildi</span> : <span className="text-emerald-700">Kaydedildi</span>}</td>
          <td className="px-3 py-2 text-xs">{LOC[r.location_status] || "-"}</td><td className="px-3 py-2 text-xs">{m(r.distance_m)}</td><td className="px-3 py-2 text-xs">{m(r.accuracy)}</td>
          <td className="px-3 py-2 text-xs text-orange-700">{r.reason || (r.flags || []).join(", ")}</td></tr>
      ))}
      {!rows.length && <tr><td colSpan={8} className="p-6 text-center text-zinc-500">Kayıt yok.</td></tr>}
    </Table>
  );
}

export default function Live() {
  const [f, setF] = useState(initRange());
  return (
    <div>
      <Title title="Devriye Canlı Takip ve Geçmiş" desc="Yalnızca okutma, giriş-çıkış ve personelin izin verdiği görev süresince paylaşılan gerçek konumlar gösterilir." />
      <h2 className="mb-2 text-lg font-bold">Şu an görevli personel</h2>
      <LiveTable />
      <h2 className="mb-2 mt-8 text-lg font-bold">Okutma geçmişi (kaydedilen ve reddedilen)</h2>
      <FilterBar f={f} setF={setF} />
      <History f={f} />
    </div>
  );
}
